import { convertBlocksToTimeRanges } from '@/common/utils/timeBlockFormatters';
import { Badge, Flex, Group, Text } from '@mantine/core';
import { useMantineTheme } from '@mantine/styles';
import { IconClock } from '@tabler/icons-react';

export interface TimeBlockBadgesProps {
    /**
     * 시간 블록 배열
     */
    blocks: number[];
    /**
     * 배지 색상, 플래너의 category.color_name (없을 경우 기본 카테고리 - red 사용)
     */
    colorName?: string;
    /**
     * 배지 크기
     * @default 'sm'
     */
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    /**
     * 시계 아이콘 보여줄지 여부
     * @default true
     */
    showIcon?: boolean;
    /**
     * 호버 중인 아이템인지 여부
     * @default false
     */
    isHovered?: boolean;
}

/**
 * 시간 블록을 시간 범위로 변환하여 배지 형태로 표시하는 컴포넌트
 */
export const TimeBlockBadges = ({
    blocks,
    colorName = 'red',
    size = 'sm',
    showIcon = true,
    isHovered = false,
}: TimeBlockBadgesProps) => {
    const theme = useMantineTheme();
    const timeRanges = convertBlocksToTimeRanges(blocks);

    if (!timeRanges.length) return null;

    return (
        <Flex wrap="wrap" rowGap="4px" columnGap="4px">
            {timeRanges.map(blockString => (
                <Badge
                    key={blockString}
                    size={size}
                    variant="filled"
                    style={{
                        backgroundColor: isHovered
                            ? theme.colors[colorName][1]
                            : theme.colors[colorName][0],
                        color: theme.colors[colorName][8],
                    }}
                >
                    <Group gap="4px">
                        {showIcon && <IconClock size={14} />}
                        <Text size="xs">{blockString}</Text>
                    </Group>
                </Badge>
            ))}
        </Flex>
    );
};
